import {IAbstractModule, IModuleType} from "@/model/Locker/IModule";

export const ModuleZ5CompB: IAbstractModule = {
    type: IModuleType.Z5comp,
    name: 'Z 5 compartment B',
    hasScreen: false,
    columns: [
        [
            {
                name: "1",
                connector: "1",
                cell_size_id: 1,
                accessible: true,
            },
            {
                name: "2",
                connector: "2",
                cell_size_id: 2,
                accessible: true,
            },
            {
                name: "3",
                connector: "3",
                cell_size_id: 2,
                accessible: true,
            },
            {
                name: "4",
                connector: "4",
                cell_size_id: 2,
                accessible: true,
            },
            {
                name: "5",
                connector: "5",
                cell_size_id: 4,
                accessible: true,
            },
        ]
    ]
}